import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing a view for filtering user aggregator relations.
 */
export default class FilterRelationUserAggregatorView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for UserPartner
                            name: 'UserPartner',
                            type: 'number',
                            label: _('Usuario Partner'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Usuario Partner'), // Localized placeholder
                        },
                        {
                            view: 'text', // Input for UserAggregator
                            name: 'UserAggregator',
                            type: 'number',
                            label: _('Usuario Aggregato'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Usuario Aggregato'), // Localized placeholder
                        },
                        {
                            view: 'text', // Input for Datepicker
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                        },
                        {
                            view: 'datepicker', // Datepicker for selecting dates
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Restrict to today's date
                                },
                            },
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing inputs
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Button to add relation
                            value: _('Añadir Relación'), // Localized button text
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            minWidth: 200,
                            hidden: !devConfig.getPermAction(
                                'relationUserAggregatorAdd',
                                'Add', // Check permission for adding relation
                            ),
                            css: 'prm-relationUserAggregatorAdd',
                            click: () => {
                                this.app.callEvent(
                                    'addRelationUserAggregator:button',
                                    [{}], // Trigger event to add relation
                                );
                            },
                        },
                        {
                            view: 'button', // Button to clear inputs
                            value: _('Limpiar'), // Localized button text
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter data
                            value: _('Consultar'), // Localized button text
                            hotkey: 'enter', // Hotkey for the button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if condition met
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if condition met
                                    }
                                }
                                this.app.callEvent(
                                    'relationUserAggregator:filter',
                                    [filterdata], // Trigger filter event with data
                                );
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main form view
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen is small
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date input if condition met
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date input
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
